/**
 * Worry Capture Tool
 *
 * Structured worry logging: capture, classify, act/postpone.
 */

import { StepFlow, saveToolEntry, initButtonGroup } from './tools-common';

export function initWorryCapture() {
    var root = document.getElementById('worry-capture');
    if (!root) return;

    var flow = new StepFlow(root);
    var worryText = '';
    var selectedTag = '';
    var worryType = '';
    var action = '';
    var actionWhen = '';

    // Tag buttons (multi-select off, single-select)
    initButtonGroup(root, '.tool-tag-btn', function (btn) {
        selectedTag = btn.dataset.tag;
    });

    // Enable/disable next button based on textarea content
    var textarea = document.getElementById('worry-text');
    var nextBtn = document.getElementById('worry-next-classify');
    if (textarea && nextBtn) {
        textarea.addEventListener('input', function () {
            nextBtn.disabled = textarea.value.trim().length === 0;
        });
    }

    // Step 1 -> Step 2
    if (nextBtn) {
        nextBtn.addEventListener('click', function () {
            worryText = textarea.value.trim();
            if (!worryText) return;
            flow.show('classify');
        });
    }

    // Step 2: Classify
    var classifyBtns = root.querySelectorAll('.tool-app__classify-btn');
    classifyBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            worryType = btn.dataset.type;
            flow.show(worryType);
        });
    });

    // Step 3a: Solvable save
    var saveSolvable = document.getElementById('worry-save-solvable');
    if (saveSolvable) {
        saveSolvable.addEventListener('click', function () {
            action = (document.getElementById('worry-action').value || '').trim();
            actionWhen = (document.getElementById('worry-when').value || '').trim();
            finishCapture();
        });
    }

    // Step 3b: Hypothetical save
    var saveHypothetical = document.getElementById('worry-save-hypothetical');
    if (saveHypothetical) {
        saveHypothetical.addEventListener('click', function () {
            finishCapture();
        });
    }

    function finishCapture() {
        var completeText = document.getElementById('worry-complete-text');
        var summaryEl = document.getElementById('worry-summary');

        if (worryType === 'solvable') {
            if (completeText) completeText.textContent = 'You identified a concrete next step. Follow through when the time comes.';
        } else {
            if (completeText) completeText.textContent = 'This worry has been postponed. Return to it during your scheduled worry time.';
        }

        if (summaryEl) {
            var html = '<p><strong>Worry:</strong> ' + escapeHtml(worryText.substring(0, 120)) + (worryText.length > 120 ? '...' : '') + '</p>';
            if (selectedTag) html += '<p><strong>Tag:</strong> ' + selectedTag + '</p>';
            html += '<p><strong>Type:</strong> ' + worryType + '</p>';
            if (worryType === 'solvable' && action) {
                html += '<p><strong>Next action:</strong> ' + escapeHtml(action) + '</p>';
                if (actionWhen) html += '<p><strong>When:</strong> ' + escapeHtml(actionWhen) + '</p>';
            }
            summaryEl.innerHTML = html;
        }

        saveToolEntry({
            tool_slug: 'worry-capture',
            entry_type: 'worry_entry',
            data: {
                text: worryText,
                tag: selectedTag,
                type: worryType,
                action: action,
                action_when: actionWhen,
            },
        });

        flow.show('complete');
    }

    // Restart
    root.querySelectorAll('.tool-restart-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
            worryText = '';
            selectedTag = '';
            worryType = '';
            action = '';
            actionWhen = '';
            if (textarea) textarea.value = '';
            if (nextBtn) nextBtn.disabled = true;
            var actionInput = document.getElementById('worry-action');
            var whenInput = document.getElementById('worry-when');
            if (actionInput) actionInput.value = '';
            if (whenInput) whenInput.value = '';
            root.querySelectorAll('.tool-tag-btn').forEach(function (b) { b.classList.remove('active'); });
            flow.reset();
        });
    });
}

function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
}
